var map = {
	"./Asset1_lrg.png": 597,
	"./Asset2_lrg.png": 598,
	"./Asset3_lrg.png": 599,
	"./Asset4_lrg.png": 600,
	"./Asset5_lrg.png": 601,
	"./Asset6_lrg.png": 602,
	"./Asset7_lrg.png": 603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 596;